import axios from 'axios';

export enum BannerCategories {
  MARKETING_BANNER = 'Communication Marketing - Actualité',
  MAINTENANCE_BANNER = 'Communication de maintenance générale',
  INCIDENT_BANNER = 'Communication sur un incident',
  INFORMATION_BANNER = 'Communication - Information',
}
const GET_ACTIVE_NEWS_ROUTE: string = 'news/show';

export interface BannerCategory {
  id: number;
  name: string;
}

export interface Banner {
  id: number;
  type: string;
  frequency?: string;
  title: string;
  description?: string;
  news?: string;
  category: BannerCategory;
}

export const getBannersTiDisplay = async (): Promise<Banner[]> => {
  const {data} = await axios.get('/api/' + GET_ACTIVE_NEWS_ROUTE);
  return data.data;
};
